export class MonthPlan {
    constructor({
          id = null,
          code= '', 
          locId= '', 
          locName= ``, 
          month= ``,
          matId= '', 
          matName= '', 
          output= '',
          operationRate='',
          qualitySpeId1= ``,
          qualitySpeCode1= ``,   
          qualitySpeUpLimit1= '',
          qualitySpeLowLimit1= '',    
          qualitySpeId2= ``,
          qualitySpeCode2= ``,   
          qualitySpeUpLimit2= '',
          qualitySpeLowLimit2= '',    
          status= '',

          qualitySpe1= '',
          qualitySpe2= '',
          monthStr= ``,
      } = {}) {
      this.id = id;
      this.code = code;
      this.locId = locId;
      this.locName = locName;
      this.month = month;
      this.matId = matId;
      this.matName = matName;  
      
      this.output = output;
      this.operationRate = operationRate;
      this.qualitySpeId1 = qualitySpeId1;
      this.qualitySpeCode1 = qualitySpeCode1;
      this.qualitySpeUpLimit1 = qualitySpeUpLimit1;
      this.qualitySpeLowLimit1 = qualitySpeLowLimit1;

      this.qualitySpeId2 = qualitySpeId2;
      this.qualitySpeCode2 = qualitySpeCode2;
      this.qualitySpeUpLimit2 = qualitySpeUpLimit2;
      this.qualitySpeLowLimit2 = qualitySpeLowLimit2;
      this.status = status;

      this.qualitySpe1 = qualitySpe1;
      this.qualitySpe2 = qualitySpe2;
      this.monthStr = monthStr;
    }
  }
  export function gridFields() {
    return Object.freeze([ 
        {
            key: 'code',
            label: 'lbl.monthPlan.code',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'locName',
            label: 'lbl.monthPlan.locName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'monthStr',
          label: 'lbl.monthPlan.month',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'matName',
          label: 'lbl.monthPlan.matName',
          form: {
            type: 'input'
          }
        },
        {
          key: 'output',
          label: 'lbl.monthPlan.output',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'operationRate',
          label: 'lbl.monthPlan.operationRate',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'qualitySpe1',
          label: 'lbl.monthPlan.qualitySpe1',
          form: {
            type: 'input'
          }
        },
        {
          key: 'qualitySpe2',
          label: 'lbl.monthPlan.qualitySpe2',
          form: {
            type: 'input'
          }
        },
        {
          key: 'status',
          label: 'lbl.monthPlan.status',
          sortable: true,
          form: {
            type: 'select',
            options: [    
                { value: null, text:  ''  },            
                { value: 'N', text:  '新生成' },
                { value: 'S', text:  '已排产' },                
                { value: 'C', text:  '已作废' },                 
              ]            
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new MonthPlan()).map(i => 'entity.' + i));

  export const filterFields = [
    'filter.codeFilter',
    'filter.locNameFilter',
    'filter.startDateFilter',
    'filter.endDateFilter',
    'filter.statusFilter'
  ];
  export const filter = {
    'codeFilter': "",
    'locNameFilter': "",
    'startDateFilter': "",
    'endDateFilter': "",
    'statusFilter': ""
  };